import * as types from "../types/nft";
import firebase from "../../firebase";
import { NFTS } from "../../models";
const algoliasearch = require("algoliasearch");

const client = algoliasearch("JCGXOT5GU1", "2d6e361518e5327352a7d7b6413ce786");
const index = client.initIndex("nfts");

export const fetchNFTWithFilter = (query, chain, tags, min, max, sortby) => {
  return async (dispatch) => {
    min = parseFloat(min);
    max = parseFloat(max);
    min = isNaN(min) ? 0 : min;
    max = isNaN(max) ? 0 : max;
    let order;
    let type;
    if (sortby === "price low to high") {
      type = "price";
      order = "asc";
    } else if (sortby === "price high to low") {
      type = "price";
      order = "desc";
    } else {
      type = "createdAt";
      order = "desc";
    }
    try {
      let nfts = [];
      dispatch({ type: types.FETCH_NFT_COLLECTION });
      if (type === "createdAt") {
        var reference = firebase
          .firestore()
          .collection("NFTDataModel")
          .limit(20)
          .where("price", ">=", min)
          .where("price", "<=", max)
          .orderBy("price", "desc")
          .orderBy(type, order);
        if (chain != "all") {
          reference = reference.where("chain", "==", chain);
        }
        if (tags.length > 0) {
          reference = reference.where("tags", "array-contains-any", tags);
        }
        reference.get().then((snapshot) => {
          if (snapshot.empty) {
            dispatch({
              type: types.FETCH_NFT_COLLECTION_SUCCESS,
              payload: { nfts },
            });
          } else {
            snapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    nfts.push(document);
                  });
                  dispatch({
                    type: types.FETCH_NFT_COLLECTION_SUCCESS,
                    payload: { nfts },
                  });
                });
              });
          }
        });
      } else if (type === "price") {
        var reference = firebase
          .firestore()
          .collection("NFTDataModel")
          .limit(20)
          .where("chain", "==", chain)
          .where("price", ">=", min)
          .where("price", "<=", max)
          .orderBy("price", order);
        if (tags.length > 0) {
          reference = reference.where("tags", "array-contains-any", tags);
        }
        reference.get().then((snapshot) => {
          if (snapshot.empty) {
            dispatch({
              type: types.FETCH_NFT_COLLECTION_SUCCESS,
              payload: { nfts },
            });
          } else {
            snapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    nfts.push(document);
                  });
                  dispatch({
                    type: types.FETCH_NFT_COLLECTION_SUCCESS,
                    payload: { nfts },
                  });
                });
              });
          }
        });
      }
    } catch (error) {
      dispatch({ type: types.FETCH_NFT_COLLECTION_FAILURE, payload: error });
    }
  };
};

export const fetchLikedNFTs = (address) => {
  return async (dispatch) => {
    try {
      let nfts = [];
      dispatch({ type: types.FETCH_NFT_COLLECTION });
      await firebase
        .firestore()
        .collection("UserDataModel")
        .limit(1)
        .where("walletAddress", "==", `${address}`)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            doc.data().likedNft.forEach((nft) => {
              firebase
                .firestore()
                .collection("NFTDataModel")
                .limit(100)
                .where(
                  firebase.firestore.FieldPath.documentId(),
                  "==",
                  `${nft}`
                )
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    let document = doc.data();
                    document.docID = doc.id;
                    firebase
                      .firestore()
                      .collection("UserDataModel")
                      .limit(1)
                      .where("walletAddress", "==", `${document.creatorAddress}`)
                      .get()
                      .then((querySnapshot) => {
                        querySnapshot.forEach((creatorDoc) => {
                          let creatorDocument = creatorDoc.data();
                          document.userImageURL = creatorDocument.imageURL;
                          document.username = creatorDocument.username;
                          nfts.push(document);
                        });
                        dispatch({
                          type: types.FETCH_NFT_COLLECTION_SUCCESS,
                          payload: { nfts },
                        });
                      });
                  });
                });
            });
          });
        });
    } catch (error) {
      dispatch({ type: types.FETCH_NFT_COLLECTION_FAILURE, payload: error });
    }
  };
};

export const fetchNFTCollection = (filter) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.FETCH_NFT_COLLECTION });
      let nfts = [];
      if (filter === "all") {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .limit(100)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    nfts.push(document);
                  });
                  dispatch({
                    type: types.FETCH_NFT_COLLECTION_SUCCESS,
                    payload: { nfts },
                  });
                });
            });
          }).catch((error) => {
            dispatch({
              type: types.FETCH_NFT_COLLECTION_FAILURE,
              payload: error.message,
            });
          });
      } else if (filter === "latest") {
        await firebase
          .firestore()
          .collection("NFTDataModel")
          .limit(8)
          .orderBy("createdAt", "desc")
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.empty) {
              dispatch({
                type: types.FETCH_NFT_COLLECTION_SUCCESS,
                payload: { nfts },
              });
            } else {
              querySnapshot.forEach((doc) => {
                let document = doc.data();
                document.docID = doc.id;
                firebase
                  .firestore()
                  .collection("UserDataModel")
                  .limit(1)
                  .where("walletAddress", "==", `${document.creatorAddress}`)
                  .get()
                  .then((querySnapshot) => {
                    querySnapshot.forEach((docuser) => {
                      const userDetail = docuser.data();
                      document.userImageURL = userDetail.imageURL;
                      document.username = userDetail.username;
                      nfts.push(document);
                    });
                    nfts.sort((a,b) => (a.createdAt > b.createdAt) ? -1 : 1)
                    dispatch({
                      type: types.FETCH_NFT_COLLECTION_SUCCESS,
                      payload: { nfts },
                    });
                  });
              });
            }
          })
          .catch((error) => {
            dispatch({
              type: types.FETCH_NFT_COLLECTION_FAILURE,
              payload: error.message,
            });
          });
      } else if (filter === "likes") {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .limit(100)
          .orderBy("likes", "desc")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    nfts.push(document);
                  });
                  dispatch({
                    type: types.FETCH_NFT_COLLECTION_SUCCESS,
                    payload: { nfts },
                  });
                });
            });
          });
      } else if (filter !== "mostpopular") {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .limit(100)
          .where("imageType", "==", `${filter}`)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.empty) {
              dispatch({
                type: types.FETCH_NFT_COLLECTION_SUCCESS,
                payload: { nfts },
              });
            } else {
              querySnapshot.forEach((doc) => {
                let document = doc.data();
                document.docID = doc.id;
                firebase
                  .firestore()
                  .collection("UserDataModel")
                  .limit(1)
                  .where("walletAddress", "==", `${document.creatorAddress}`)
                  .get()
                  .then((querySnapshot) => {
                    querySnapshot.forEach((docuser) => {
                      const userDetail = docuser.data();
                      document.userImageURL = userDetail.imageURL;
                      document.username = userDetail.username;
                      nfts.push(document);
                    });
                    dispatch({
                      type: types.FETCH_NFT_COLLECTION_SUCCESS,
                      payload: { nfts },
                    });
                  });
              });
            }
          })
          .catch((error) => {
            dispatch({
              type: types.FETCH_NFT_COLLECTION_FAILURE,
              payload: error.message,
            });
          });
      } else {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .limit(100)
          .orderBy("score", "desc")
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.empty) {
              dispatch({
                type: types.FETCH_NFT_COLLECTION_SUCCESS,
                payload: { nfts },
              });
            } else {
              querySnapshot.forEach((doc) => {
                let document = doc.data();
                document.docID = doc.id;
                firebase
                  .firestore()
                  .collection("UserDataModel")
                  .limit(1)
                  .where("walletAddress", "==", `${document.creatorAddress}`)
                  .get()
                  .then((querySnapshot) => {
                    querySnapshot.forEach((docuser) => {
                      const userDetail = docuser.data();
                      document.userImageURL = userDetail.imageURL;
                      document.username = userDetail.username;
                      nfts.push(document);
                    });
                    dispatch({
                      type: types.FETCH_NFT_COLLECTION_SUCCESS,
                      payload: { nfts },
                    });
                  });
              });
            }
          })
          .catch((error) => {
            dispatch({
              type: types.FETCH_NFT_COLLECTION_FAILURE,
              payload: error.message,
            });
          });
      }
    } catch (error) {
      dispatch({
        type: types.FETCH_NFT_COLLECTION_FAILURE,
        payload: error.message,
      });
    }
  };
};

export const searchInNFTCollection = (value) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.FETCH_NFT_COLLECTION });
      let searchedNFTs = [];
      index.search(value).then((objects) => {
        objects.hits.forEach((hit) => {
          console.log(hit);
          searchedNFTs.push(hit);
        });
        dispatch({
          type: types.SEARCH_NFT_COLLECTION_SUCCESS,
          payload: { searchedNFTs },
        });
      });
    } catch (error) {
      dispatch({
        type: types.SEARCH_NFT_COLLECTION_FAILURE,
        payload: error.message,
      });
    }
  };
};

export const filterNFTByTAGS = (tags, searchVal) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.FILTER_NFT_BY_TAGS, payload: searchVal });
      let searchedNFTs = [];
      if (searchVal === "") {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .where("tags", "==", tags)
          .orderBy("views", "desc")
          .onSnapshot((snapshot) => {
            snapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  console.log("querySnapshot", querySnapshot);
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    searchedNFTs.push(document);
                  });
                  dispatch({
                    type: types.FILTER_NFT_BY_TAGS_SUCCESS,
                    payload: { searchedNFTs },
                  });
                })
                .catch((error) => {
                  console.log("error >>>>>>>>>>> ", error);
                });
            });
          });
      } else {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .where("tags", "==", tags)
          .where("name", "==", searchVal)
          .orderBy("views", "desc")
          .onSnapshot((snapshot) => {
            snapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  console.log("querySnapshot", querySnapshot);
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    searchedNFTs.push(document);
                  });
                  dispatch({
                    type: types.FILTER_NFT_BY_TAGS_SUCCESS,
                    payload: { searchedNFTs },
                  });
                })
                .catch((error) => {
                  console.log("error >>>>>>>>>>> ", error);
                });
            });
          });
      }

      dispatch({
        type: types.FILTER_NFT_BY_TAGS_SUCCESS,
        payload: { searchedNFTs },
      });
    } catch (e) {
      dispatch({ type: types.FILTER_NFT_BY_TAGS_FAILURE, payload: e.message });
    }
  };
};

export const filterNFTByChain = (chain, searchVal) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.FILTER_NFT_BY_TAGS, payload: chain });
      let searchedNFTs = [];
      if (searchVal === "") {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .where("chain", "==", chain)
          .orderBy("views", "desc")
          .onSnapshot((snapshot) => {
            snapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  console.log("querySnapshot", querySnapshot);
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    searchedNFTs.push(document);
                  });
                  dispatch({
                    type: types.FILTER_NFT_BY_TAGS_SUCCESS,
                    payload: { searchedNFTs },
                  });
                })
                .catch((error) => {
                  console.log("error >>>>>>>>>>> ", error);
                });
            });
          });
      } else {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .where("chain", "==", chain)
          .where("name", "==", searchVal)
          .orderBy("views", "desc")
          .onSnapshot((snapshot) => {
            snapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    searchedNFTs.push(document);
                  });
                  dispatch({
                    type: types.FILTER_NFT_BY_TAGS_SUCCESS,
                    payload: { searchedNFTs },
                  });
                })
                .catch((error) => {
                  dispatch({
                    type: types.FILTER_NFT_BY_TAGS_FAILURE,
                    payload: error.message,
                  });
                });
            });
          });
      }

      dispatch({
        type: types.FILTER_NFT_BY_TAGS_SUCCESS,
        payload: { searchedNFTs },
      });
    } catch (e) {
      dispatch({ type: types.FILTER_NFT_BY_TAGS_FAILURE, payload: e.message });
    }
  };
};

export const sortByPrice = (order) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SORT_BY_PRICE });
      let nfts = [];
      await firebase
        .firestore()
        .collection("NFTDataModel")
        .limit(100)
        .orderBy("price", `${order}`)
        .onSnapshot((snapshot) => {
          snapshot.forEach((doc) => {
            let document = doc.data();
            document.docID = doc.id;
            firebase
              .firestore()
              .collection("UserDataModel")
              .limit(1)
              .where("walletAddress", "==", `${document.creatorAddress}`)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((docuser) => {
                  const userDetail = docuser.data();
                  document.userImageURL = userDetail.imageURL;
                  document.username = userDetail.username;
                  nfts.push(document);
                });
                dispatch({
                  type: types.SORT_BY_PRICE_SUCCESS,
                  payload: { nfts },
                });
              })
              .catch((error) => {
                dispatch({
                  type: types.SORT_BY_PRICE_FAILURE,
                  payload: error.message,
                });
              });
          });
        });
    } catch (error) {
      dispatch({ type: types.SORT_BY_PRICE_FAILURE, payload: error.message });
    }
  };
};

export const sortByPriceAndSearch = (order, searchVal) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SORT_BY_PRICE });
      let nfts = [];

      await firebase
        .firestore()
        .collection("NFTDataModel")
        .limit(100)
        .orderBy("price", `${order}`)
        .onSnapshot((snapshot) => {
          snapshot.forEach((doc) => {
            let document = doc.data();
            document.docID = doc.id;
            firebase
              .firestore()
              .collection("UserDataModel")
              .limit(1)
              .where("walletAddress", "==", `${document.creatorAddress}`)
              .where("name", "==", searchVal)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((docuser) => {
                  const userDetail = docuser.data();
                  document.userImageURL = userDetail.imageURL;
                  document.username = userDetail.username;
                  nfts.push(document);
                });
                dispatch({
                  type: types.SORT_BY_PRICE_SUCCESS,
                  payload: { nfts },
                });
              })
              .catch((error) => {
                dispatch({
                  type: types.SORT_BY_PRICE_FAILURE,
                  payload: error.message,
                });
              });
          });
        });
    } catch (error) {
      dispatch({ type: types.SORT_BY_PRICE_FAILURE, payload: error.message });
    }
  };
};

export const sortByPriceAndFilterByChain = (order, chain) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SORT_BY_PRICE });
      let nfts = [];
      await firebase
        .firestore()
        .collection("NFTDataModel")
        .limit(100)
        .where("chain", "==", chain)
        .orderBy("price", `${order}`)
        .onSnapshot((snapshot) => {
          snapshot.forEach((doc) => {
            let document = doc.data();
            document.docID = doc.id;
            firebase
              .firestore()
              .collection("UserDataModel")
              .limit(1)
              .where("walletAddress", "==", `${document.creatorAddress}`)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((docuser) => {
                  const userDetail = docuser.data();
                  document.userImageURL = userDetail.imageURL;
                  document.username = userDetail.username;
                  nfts.push(document);
                });
                dispatch({
                  type: types.SORT_BY_PRICE_SUCCESS,
                  payload: { nfts },
                });
              })
              .catch((error) => {
                dispatch({
                  type: types.SORT_BY_PRICE_FAILURE,
                  payload: error.message,
                });
              });
          });
        });
    } catch (error) {
      dispatch({ type: types.SORT_BY_PRICE_FAILURE, payload: error.message });
    }
  };
};

export const filterAndSearchInNFTCollection = (filter, value) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.FILTER_SEARCH_NFT_COLLECTION, payload: value });
      let searchedNFTs = [];
      if (filter !== "mostpopular") {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .where("name", "==", value)
          .where("imageType", "==", filter)
          .orderBy("views", "desc")
          .onSnapshot((snapshot) => {
            snapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    searchedNFTs.push(document);
                  });
                })
                .catch((error) => {
                  dispatch({
                    type: types.FILTER_SEARCH_NFT_COLLECTION_FAILURE,
                    payload: error.message,
                  });
                });
            });
          });
      } else {
        firebase
          .firestore()
          .collection("NFTDataModel")
          .where("name", "==", value)
          .orderBy("score", "desc")
          .onSnapshot((snapshot) => {
            snapshot.forEach((doc) => {
              let document = doc.data();
              document.docID = doc.id;
              firebase
                .firestore()
                .collection("UserDataModel")
                .limit(1)
                .where("walletAddress", "==", `${document.creatorAddress}`)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((docuser) => {
                    const userDetail = docuser.data();
                    document.userImageURL = userDetail.imageURL;
                    document.username = userDetail.username;
                    searchedNFTs.push(document);
                  });
                })
                .catch((error) => {
                  dispatch({
                    type: types.FILTER_SEARCH_NFT_COLLECTION_FAILURE,
                    payload: error.message,
                  });
                });
            });
          });
      }
      dispatch({
        type: types.FILTER_SEARCH_NFT_COLLECTION_SUCCESS,
        payload: { searchedNFTs },
      });
    } catch (error) {
      dispatch({
        type: types.FILTER_SEARCH_NFT_COLLECTION_FAILURE,
        payload: error.message,
      });
    }
  };
};
